import { Component, OnInit } from '@angular/core';
import { ComponentBaseComponent } from '@app/core/components/component-base/component-base.component';
import { FormButton } from '@app/core/components/form-field-button/form-field-button.component';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { DataTaskService } from '@app/core/services/data-task.service';

@Component({
    selector: 'tt-products-overview',
    templateUrl: './products-overview.component.html',
    styleUrls: ['./products-overview.component.css'],
})
export class ProductsOverviewComponent extends ComponentBaseComponent implements OnInit {
    public get?: ProductOverviewGet;

    public grid?: GridOptions;

    public searchButtons: FormButton[] = [{ id: 'search', icon: 'fas fa-search', type: 'primary', onClick: () => this.readGrid() }];

    constructor(private datatask: DataTaskService) {
        super();
    }

    public readGrid() {
        if (!this.grid) {
            this.createGrid();
        } else {
            this.grid.gridfunc?.read();
        }
    }

    public createGrid() {
        if (!!this.get) {
            this.grid = new Grid().setRememberId('w_productoverview.grid').setLoadDataFunction({ method: 3714, parameters: () => this.get });
        }
    }

    public async loadGet() {
        this.get = (await this.datatask.Post(3713))[0];
    }

    async ngOnInit(): Promise<void> {
        await this.loadGet();

        if (!!this.get?.searchtext?.trim()) {
            this.createGrid();
        }
    }
}

export interface ProductOverviewGet {
    searchtext: string;
    showsettings: '1' | '0';
}
